
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { pricingPlans, modelComparisonData, faqData } from '@/config/pricingPlans';
import { PricingPlan } from '@/config/pricingPlans';
import Navbar from '@/components/Navbar';
import LaunchButton from '@/components/LaunchButton';
import FAQSection from '@/components/FAQSection';
import HeroSection from '@/components/home/HeroSection';
import PricingComparisonSection from '@/components/home/PricingComparisonSection';
import FeaturesSection from '@/components/home/FeaturesSection';
import PricingSection from '@/components/home/PricingSection';
import Footer from '@/components/home/Footer';

const Index = () => {
  const navigate = useNavigate();
  
  // Use useMemo instead of useState for static data
  const plans = useMemo(() => Object.values(pricingPlans), []);
  const models = useMemo(() => modelComparisonData, []);
  
  const navigateToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };
  
  const handlePlanClick = (planId: string) => {
    navigate(`/checkout?plan=${planId}`);
    toast(`Processing your ${planId.charAt(0).toUpperCase() + planId.slice(1)} plan selection`);
  };

  return (
    <div>
      <Navbar className="z-10" />
      
      <HeroSection onPricingClick={navigateToPricing} />
      
      <PricingComparisonSection onPricingClick={navigateToPricing} />
      
      <FeaturesSection />
      
      <section className="py-12 px-4 bg-gradient-to-r from-krix-purple to-krix-blue">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Launch Special: Save Up to 70% Today</h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto mb-8">
            Early adopters get our plans at special introductory pricing, available for a limited time only.
          </p>
          
          <LaunchButton
            variant="default"
            size="lg"
            className="bg-white text-krix-purple hover:bg-white/90"
            onClick={() => navigate('/checkout')}
          >
            Claim Your Discount
          </LaunchButton>
        </div>
      </section>
      
      <PricingSection
        plans={plans}
        models={models}
        isLoading={false}
        onPlanClick={handlePlanClick}
      />
      
      <section id="faq" className="py-16 px-4 bg-muted/30">
        <FAQSection faqs={faqData} />
      </section>
      
      <section className="py-16 px-4 bg-gradient-to-br from-krix-purple/10 via-white to-krix-blue/10">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Access All the Best AI Models?</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Join now and lock in our special launch pricing forever. Get access to 20+ AI models for a fraction of the cost.
          </p>
          
          <LaunchButton variant="cta" size="lg" onClick={navigateToPricing}>
            Get Started Now
          </LaunchButton>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Index;
